import AddIcon from "@mui/icons-material/Add";
import { Box, Chip, Grid, Stack, Typography, useTheme } from "@mui/material";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import { t } from "i18next";
import moment from "moment";
import { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import ServiceCard from "../../../components/serviceCard";
import TextInput from "../../../components/TextInputs";
import globalStyle from "../../../globalStyle";
import { setSelectedServices } from "../../../lib/CompanySlice/SelectedServicesSlice";
import { setSelectionType } from "../../../lib/CompanySlice/SelectionTypeSlice";
import SelectTime from "./SelectTime";

const buttonStyle = {
  height: 40,
};

const CreateNewAppointment = ({ setIsOpen }) => {
  const { palette } = useTheme();
  const openTimeDrawerRef = useRef(null);
  const dispatch = useDispatch();
  const todayDate = new Date();

  const selectedService = useSelector(
    (state) => state.seletedServicesReducer.selectedServices
  );

  const handleRemoveService = (data, index) => {
    let tempArr = [...selectedService];
    tempArr.splice(index, 1);
    dispatch(setSelectedServices(tempArr));
  };

  return (
    <>
      <Stack height={"100vh"} justifyContent={"space-between"}>
        {/* Drawe header   */}
        <Stack
          p={2}
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          borderBottom={`1px solid ${palette.custom.borderColor}`}
        >
          <Box>
            <Typography
              variant="h5"
              fontWeight={500}
              color={"custom.pictonBlue"}
              textTransform={"capitalize"}
            >
              {t("createNewAppointment")}
            </Typography>
            <Typography>
              {t("source")} :{" "}
              <span style={{ color: palette.primary.main }}>Walk In</span>
            </Typography>
          </Box>
          <Box>
            <Typography fontSize={"0.75rem"}>
              {moment(todayDate).format("DD/MM/YYYY")}
            </Typography>
            <Typography fontSize={"0.75rem"}>
              {moment(todayDate).format("ddd hh:mm a")}
            </Typography>
          </Box>
        </Stack>

        {/* Drawer Body */}

        <Box height={"100%"} p={2} overflow={"auto"}>
          <Typography variant="body1" fontWeight={500}>
            {t("service")}
          </Typography>
          <Stack direction={"row"} justifyContent={"flex-end"}>
            <Chip
              icon={<AddIcon />}
              variant="outlined"
              label={t("addService")}
              sx={{ borderRadius: 2 }}
              onClick={() => {
                dispatch(setSelectionType("add_service"));
              }}
            />
          </Stack>

          <Stack>
            {selectedService?.map((val, index) => {
              return (
                <ServiceCard
                  key={index}
                  index={index}
                  data={val}
                  showActions={true}
                  showDelete={true}
                  handleDelete={handleRemoveService}
                />
              );
            })}
          </Stack>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Label labelText={t("date")} required />
              <DatePicker
                sx={{
                  "&.MuiTextField-root": { width: "100% !important" },
                  ...globalStyle.textField,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Label labelText={t("from")} required />
              <TimePicker
                sx={{
                  "&.MuiTextField-root": { width: "100% !important" },
                  ...globalStyle.textField,
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <Label labelText={t("to")} required />
              <TimePicker
                sx={{
                  "&.MuiTextField-root": { width: "100% !important" },
                  ...globalStyle.textField,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              <Label labelText={t("note")} required />
              <TextInput
                styleProps={{
                  "& .MuiInputBase-root": { padding: "0px" },
                  ...globalStyle.textField,
                }}
                placeholder={t("enterDescriptionOrNote")}
                multiline
                rows={4}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Drawer Footer */}

        <Box
          p={"8px 16px"}
          borderTop={`1px solid ${palette.custom.borderColor}`}
        >
          <Stack
            mb={1}
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography variant="h6" fontWeight={500}>
              {t("total")}
            </Typography>
            <Stack direction={"row"} alignItems={"center"} gap={3}>
              <Typography variant="body2">2hr & 30min</Typography>
              <Typography variant="h6" fontWeight={500}>
                $240
              </Typography>
            </Stack>
          </Stack>
          <Stack direction={"row"} spacing={1}>
            <GlobalButton
              variant={"outlined"}
              btnText={"goBack"}
              styleProps={buttonStyle}
              handleClickBtn={() => {
                dispatch(setSelectionType("add_service"));
              }}
            />
            <GlobalButton
              variant={"contained"}
              btnText={"save"}
              styleProps={buttonStyle}
              handleClickBtn={() => {
                setIsOpen(false);
              }}
            />
          </Stack>
        </Box>
      </Stack>
      <SelectTime ref={openTimeDrawerRef} />
    </>
  );
};

export default CreateNewAppointment;
